import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownTopCombinationMini = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5.06557 5L9 1", stroke: "#434343", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDownTopCombinationMini);
export { ForwardRef as ReactComponent };
